import { inject, Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class IconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  static svgIcons = [
    "round_progress_empty",
    "round_progress_quarter",
    "round_progress_3_quarter",
    "round_progress_half",
    "round_progress_full",
    "arrow_left_circle",
    "google_icon",
    "microsoft_icon",
  ];

  constructor() {}

  initIcons() {
    this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
    for (let icon of IconService.svgIcons) {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${icon}.svg`,
        ),
      );
    }
  }

  static isSvgIcon(icon: string) {
    return IconService.svgIcons.includes(icon);
  }
}
